import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import classNames from 'classnames';
import { isEqual } from 'lodash';
import { Image } from '@components/common';

class Timeline extends Component {
	shouldComponentUpdate = ({ data, fromFeeds }) => {
		const lastProps = this.props;
		return (
			!isEqual(lastProps.data, data)
			|| !isEqual(lastProps.fromFeeds, fromFeeds)
		);
	};

	getFeedList() {
		const { data } = this.props;
		const noOfItems = data.length - 1;
		return data.map((item, index) => (
			<li
				className={classNames('timeline-details', { first : index === 0, last : index === noOfItems, all : index !== 0 && index !== noOfItems })}
				key={item.id}
			>
				<div className="flex">
					<div className="flex flex-direction-column">
						<h5 className="margin-0">{ moment(item.date).format('DD MMM') }</h5>
						<span className="font-size-10 font-regular-italic padding-bottom-5">{ moment(item.date).format('hh:mm A') }</span>
					</div>
					<div className="margin-left-40 margin-top--3 flex-3 flex flex-direction-column">
						<span className="font-size-14 font-regular padding-bottom-5">{ item.type }</span>
						<span className="font-size-12 font-bold">{ item.title }</span>
						<span className="font-size-12 padding-bottom-5">{ item.content }</span>
						<span className="font-size-12 font-regular-italic padding-bottom-5">
							Posted by :
							{ item.postedBy }
						</span>
						<If condition={item.image}>
							<a
								href={item.image}
								className="height-100 width-100 margin-top-10"
								target="_blank"
								rel="noreferrer"
							>
								<Image
									className="height-100 width-100"
									src={item.image || ''}
								/>
							</a>
						</If>
					</div>
				</div>
			</li>
		));
	}

	getItems = () => {
		const {
			data,
			labelClassName,
			valueClassName,
		} = this.props;

		return data.map((item) => (
			<li
				className="timeline-details"
				key={item.id}
			>
				<span className={labelClassName}>{ item.label }</span>
				<span className={valueClassName}>{ item.value }</span>
			</li>
		));
	}

	render() {
		const {
			outerClassName,
			header,
			headerClassName,
			fromFeeds,
		} = this.props;

		return (
			<div className={outerClassName}>
				<If condition={header}>
					<span className={`padding-left-20 ${headerClassName}`}>{ header }</span>
				</If>
				<ul className="timeline margin-top-20">
					<Choose>
						<When condition={fromFeeds}>
							{ this.getFeedList() }
						</When>
						<Otherwise>
							{ this.getItems() }
						</Otherwise>
					</Choose>
				</ul>
			</div>
		);
	}
}

Timeline.propTypes = {
	data            : PropTypes.array,
	header          : PropTypes.string,
	outerClassName  : PropTypes.string,
	headerClassName : PropTypes.string,
	labelClassName  : PropTypes.string,
	valueClassName  : PropTypes.string,
	fromFeeds       : PropTypes.bool,
};

Timeline.defaultProps = {
	data            : [],
	header          : '',
	outerClassName  : '',
	headerClassName : 'font-size-16 color-dark',
	labelClassName  : 'font-size-12',
	valueClassName  : 'font-size-10',
	fromFeeds       : false,
};

export default Timeline;
